module.exports = __webpack_public_path__ + "img/professor_male.d45fe5d1.png";